module.exports = __webpack_public_path__ + "img/headset_mic.5ac82615.svg";